import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/** Platform-wide analytics overview returned by GET /api/analytics/overview. */
export interface AnalyticsOverview {
  organizations: { districts: number; schools: number };
  users: { total: number; students: number; staff: number; administrators: number };
  content: { posts: number; comments: number; messages: number; events: number };
  connections: { accepted: number; pending: number; total: number };
  profileCompletion: {
    average: number;
    fullyComplete: number;
    totalProfiles: number;
    buckets: { label: string; count: number }[];
  };
  moderation: {
    totalReports: number;
    byStatus: { status: string; count: number }[];
    byReason: { reason: string; count: number }[];
    byType: { post: number; comment: number };
  };
  featureUsage: { feature: string; count: number }[];
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private http: HttpClient = inject(HttpClient);

  /**
   * Fetches platform-wide analytics metrics.
   * @returns {Observable<AnalyticsOverview>}
   */
  getOverview(): Observable<AnalyticsOverview> {
    return this.http.get<AnalyticsOverview>('/api/analytics/overview');
  }
}
